export default [

	{
	 'id': 'none',
	 'type': 'color',
	 'color': 'rgba(0,0,0,0)'
	},
	{
	 'id': 'red',
	 'type': 'color',
	 'color': '#f44259'
	},
	{
	 'id': 'orange',
	 'type': 'color',
	 'color': '#ff8f3f'
	},
	{
	 'id': 'yellow',
	 'type': 'color',
	 'color': '#fff53d'
	},
	{
	 'id': 'green',
	 'type': 'color',
	 'color': '#40f975'
	},
	{
	 'id': 'blue',
	 'type': 'color',
	 'color': '#3f7ffb'
	},
	{
	 'id': 'purple',
	 'type': 'color',
	 'color': '#a544ff'
	},
	{
	 'id': 'pink',
	 'type': 'color',
	 'color': '#ef4cc6'
	}

]


// WEBPACK FOOTER //
// ./src/data/Colors.js